import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

interface Props {
  value?: string | null
  values: Array<string>
  select: (value: string) => void,
  selectHeader?: string
  textPrefix: string
  textPlaceholder: string
  textPostfix: string
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-explanation-controls',
  props: {
    value: null,
    values: null,
    select: null,
    selectHeader: null,
    textPrefix: null,
    textPlaceholder: null,
    textPostfix: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  value?: string | null
  values: Array<string>
  select: (value: string) => void,
  selectHeader?: string
  textPrefix: string
  textPlaceholder: string
  textPostfix: string
  disabled?: boolean
}




const count = ref(0)

const showPlaceholder = ref(true)

const items = () => {
    if (props.selectHeader) {
        return [{ text: props.selectHeader, disabled: true }, ...props.values]
    }

    return props.values
}
const onChange = (value: string) => {
    showPlaceholder.value = true
    if (value === '') {
        return
    }

    props.select(value)

    count.value += 1
}

return { __sfc: true,props, count, showPlaceholder, items, onChange }
}

})